import { render, staticRenderFns } from "./BookmarkItem.vue?vue&type=template&id=6c12125f&scoped=true&"
import script from "./BookmarkItem.vue?vue&type=script&lang=ts&"
export * from "./BookmarkItem.vue?vue&type=script&lang=ts&"
import style0 from "./BookmarkItem.vue?vue&type=style&index=0&id=6c12125f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c12125f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
